import { MenuBottom } from "../blocks/MenuBottom/MenuBottom";
import Header from "../components/header/header";

import { UslugaFindByUrlResponse } from "@project/shared-types";
import { useLoaderData } from "react-router";
import { BlocksBuilder } from "../blocks/BlocksBuilder/BlocksBuilder";
import { Footer } from "../blocks/Footer/Footer";
import { Services } from "../blocks/sevices/services";
import { WorkPromo } from "../blocks/workpromo/workpromo";
import { ScrollBlock } from "../components/others/ScrollBlock";
import { UserProvider } from "../context/user/UserContext";
import "../core/core.css";
import { DataProvider } from "../hooks/DataContext";
import { SupportProvider } from "../Support/SupportProvider";

const Usluga = () => {
  const data = useLoaderData<UslugaFindByUrlResponse>();
  return (
    <DataProvider>
      <UserProvider>
        <SupportProvider>
          <title>{data.page?.title}</title>
          <link rel="canonical" href={`https://hmrep.ru/uslugi/${data.page?.url}`} />
          <meta name="description" content={data.page?.description} />
          <meta property="og:title" content={data.page?.title} />
          <meta property="og:description" content={data.page?.description} />
          <div className="body">
            <ScrollBlock></ScrollBlock>
            <Header></Header>
            <div className="blocks">
              <BlocksBuilder></BlocksBuilder>
              <Services
                exclude_ids={
                  data.usluga?.product_id ? [data.usluga?.product_id] : []
                }
              ></Services>
              <WorkPromo></WorkPromo>
              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};
export default Usluga;
